// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#post-credit-plan {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  z-index: 9999;
  overflow-y: auto;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}
#post-credit-plan.modal-open {
  opacity: 1;
  transform: translateY(0);
}
#post-credit-plan .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  margin-bottom: 64px;
}
#post-credit-plan .header {
  display: flex;
  margin-top: 28px;
  margin-bottom: 32px;
  justify-content: space-between;
}
#post-credit-plan .header-middle {
  gap: 16px;
  display: flex;
  align-items: center;
}
#post-credit-plan .header img {
  width: 209px;
  height: 20px;
}
#post-credit-plan .header h2 {
  font-size: 33px;
  font-weight: 700;
  font-style: normal;
  font-family: "Campuni";
  color: var(--sebrae-blue-6);
}
#post-credit-plan .header h4 {
  font-size: 19px;
  font-weight: 400;
  font-style: normal;
  color: var(--sebrae-blue-2);
}
#post-credit-plan .information-box {
  gap: 20px;
  display: flex;
  padding: 8px 16px;
  border-radius: 4px;
  flex-direction: column;
  background-color: #ebe8ff;
  max-height: 1000px;
  overflow: hidden;
  transition: max-height 0.4s ease, padding 0.4s ease, opacity 0.3s ease, min-height 0.4s ease;
}
#post-credit-plan .information-box:not(.collapsed) {
  min-height: 128px;
}
#post-credit-plan .information-box.collapsed {
  max-height: 0;
  min-height: 0;
  padding: 0 16px;
  opacity: 0;
}
#post-credit-plan .information-box-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
#post-credit-plan .information-box-header svg {
  cursor: pointer;
  transition: transform 0.2s ease;
}
#post-credit-plan .information-box-header svg:hover {
  transform: scale(1.2);
}
#post-credit-plan .information-box-texts {
  gap: 8px;
  display: flex;
  flex-direction: column;
  transition: opacity 0.3s ease;
}
#post-credit-plan .information-box-texts p {
  font-size: 13px;
  font-weight: 400;
  font-style: normal;
}
#post-credit-plan .information-box-texts p span {
  font-weight: 700;
}
#post-credit-plan .information-box.collapsed #post-credit-plan .information-box-texts {
  opacity: 0;
}
#post-credit-plan .information-box h4 {
  font-size: 16px;
  margin-top: 4px;
  font-weight: 700;
  font-style: normal;
  color: var(--sebrae-blue-6);
}
#post-credit-plan .double-container {
  margin-top: 32px;
  gap: 20px;
  width: 100%;
  display: flex;
}
@media (min-width: 1100px) {
  #post-credit-plan .double-container {
    gap: 40px;
  }
}
#post-credit-plan .double-container .left-container,
#post-credit-plan .double-container .right-container {
  flex: 1 1;
}
#post-credit-plan .double-container .left-container {
  max-width: 500px;
  padding: 32px;
  border-radius: 8px;
  border: 1px solid var(--sebrae-light-gray4);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
}
#post-credit-plan .double-container .left-container-title {
  gap: 8px;
  display: flex;
  margin-bottom: 24px;
  flex-direction: column;
}
#post-credit-plan .double-container .left-container h3 {
  font-size: 27px;
  font-weight: 700;
  font-family: Campuni;
  color: var(--sebrae-blue-6);
}
#post-credit-plan .double-container .left-container .left-content {
  width: 100%;
  margin-top: 10.5px;
}
#post-credit-plan .double-container .left-container .left-content h6 {
  font-size: 16px;
  font-weight: 700;
  color: var(--sebrae-blue-6);
}
#post-credit-plan .double-container .left-container .left-content .first-row {
  gap: 16px;
  display: flex;
  margin-top: 8px;
}
#post-credit-plan .double-container .left-container .left-content .first-row input {
  flex: 1 1;
}
#post-credit-plan .double-container .left-container > .accordion-graphics-container > .panel > div > .monthly-average .step--info,
#post-credit-plan .double-container .left-container > .accordion-graphics-container > .panel > div > .monthly-average .BaSe--input-sub-label,
#post-credit-plan .double-container .left-container .variable-indirect-costs .step--info,
#post-credit-plan .double-container .left-container .variable-indirect-costs .BaSe--input-sub-label,
#post-credit-plan .double-container .left-container .total-investment .step--info,
#post-credit-plan .double-container .left-container .total-investment .BaSe--input-sub-label {
  display: none;
}
#post-credit-plan .double-container .left-container > .accordion-graphics-container > .panel > div > .monthly-average .BaSe--input,
#post-credit-plan .double-container .left-container .variable-indirect-costs .BaSe--input,
#post-credit-plan .double-container .left-container .total-investment .BaSe--input {
  margin-bottom: 0;
}
#post-credit-plan .double-container .left-container > .accordion-graphics-container > .panel > div > .total-investment .BaSe--grid {
  align-items: end;
  gap: 16px !important;
}
#post-credit-plan .double-container .left-container .finish-month {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
#post-credit-plan .double-container .left-container .finish-month-info {
  display: flex;
  padding: 24px;
  flex-direction: column;
  background-color: #ebe8ff;
}
#post-credit-plan .double-container .left-container .finish-month-info-header {
  display: flex;
  justify-content: flex-start;
  gap: 4px;
}
#post-credit-plan .double-container .left-container .finish-month-info-header h4 {
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  color: var(--sebrae-blue-6);
}
#post-credit-plan .double-container .left-container .finish-month-info-texts {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
#post-credit-plan .double-container .left-container .finish-month-info-texts p {
  font-size: 13px;
  font-weight: 400;
}
#post-credit-plan .double-container .left-container .finish-month button {
  height: 40px;
  width: 156px;
  background-color: var(--sebrae-blue-6);
  color: var(--sebrae-white);
  border: none;
  border-radius: 4px;
  font-size: 18px;
  line-height: 23.3px;
  cursor: pointer;
}
#post-credit-plan .double-container .right-container .step-components-area {
  padding: 0 74.5px;
}
#post-credit-plan .double-container .right-container .date-area {
  gap: 24px;
  display: flex;
  margin: 24px 0;
}
#post-credit-plan .double-container .right-container-description {
  font-size: 19px;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 24px;
  color: var(--sebrae-gray);
}
#post-credit-plan .double-container .right-container-header {
  display: flex;
  font-family: Campuni;
  justify-content: space-between;
}
#post-credit-plan .double-container .right-container-header h2 {
  font-size: 36px;
  font-weight: 700;
  color: var(--sebrae-blue-6);
}
#post-credit-plan .double-container .right-container-header button {
  font-size: 16px;
  max-width: 144px;
  font-weight: 700;
  font-family: Figtree;
}
#post-credit-plan .double-container .right-container-info,
#post-credit-plan .double-container .right-container .payment-capacity {
  width: 100%;
}
#post-credit-plan .double-container .right-container-info .data,
#post-credit-plan .double-container .right-container .payment-capacity .data {
  gap: 24px;
  display: flex;
  margin-top: 24px;
  flex-direction: column;
  justify-content: space-between;
}
#post-credit-plan .double-container .right-container-info .data-values-matriz,
#post-credit-plan .double-container .right-container .payment-capacity .data-values-matriz {
  padding: 16px;
  margin-top: 24px;
  border-radius: 0 0 4px 4px;
  border: 1px solid var(--sebrae-light-blue3);
}
#post-credit-plan .double-container .right-container-info .data-values-matriz h4,
#post-credit-plan .double-container .right-container .payment-capacity .data-values-matriz h4 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--sebrae-blue);
}
#post-credit-plan .double-container .right-container-info .data-values-matriz .value,
#post-credit-plan .double-container .right-container .payment-capacity .data-values-matriz .value {
  font-size: 19px;
  font-weight: 700;
}
#post-credit-plan .double-container .right-container-info .data-values-matriz .nivel,
#post-credit-plan .double-container .right-container .payment-capacity .data-values-matriz .nivel {
  font-size: 11px;
  font-weight: 400;
}
#post-credit-plan .double-container .right-container-info .data-values-matriz .nivel.baixo,
#post-credit-plan .double-container .right-container .payment-capacity .data-values-matriz .nivel.baixo {
  color: #3cb371;
}
#post-credit-plan .double-container .right-container-info .data-values-matriz .nivel.moderado,
#post-credit-plan .double-container .right-container .payment-capacity .data-values-matriz .nivel.moderado {
  color: #664d1a;
}
#post-credit-plan .double-container .right-container-info .data-values-matriz .nivel.alto,
#post-credit-plan .double-container .right-container .payment-capacity .data-values-matriz .nivel.alto {
  color: #ff7043;
}
#post-credit-plan .double-container .right-container-info .data-values-matriz .nivel.critico,
#post-credit-plan .double-container .right-container .payment-capacity .data-values-matriz .nivel.critico {
  color: #d9534f;
}
#post-credit-plan .double-container .right-container-info .data-values,
#post-credit-plan .double-container .right-container .payment-capacity .data-values {
  display: flex;
  gap: 24px;
  width: 260px;
  max-width: 240px;
  flex-direction: column;
}
#post-credit-plan .double-container .right-container-info .data-values > div,
#post-credit-plan .double-container .right-container .payment-capacity .data-values > div {
  padding: 16px;
  border-radius: 4px;
  border: 1px solid var(--sebrae-light-blue3);
}
#post-credit-plan .double-container .right-container-info .data-values > div h4,
#post-credit-plan .double-container .right-container .payment-capacity .data-values > div h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--sebrae-blue);
}
#post-credit-plan .double-container .right-container-info .data-values > div .value,
#post-credit-plan .double-container .right-container .payment-capacity .data-values > div .value {
  display: block;
  font-size: 19px;
  font-weight: 700;
  color: var(--sebrae-gray);
}
#post-credit-plan .double-container .right-container-info .data-values > div p,
#post-credit-plan .double-container .right-container .payment-capacity .data-values > div p {
  font-size: 13px;
  margin-top: 2px;
  font-weight: 600;
}
#post-credit-plan .double-container .right-container-info .data-values > div p.below,
#post-credit-plan .double-container .right-container .payment-capacity .data-values > div p.below {
  font-size: 11px;
  font-weight: 400;
  color: var(--sebrae-red);
}
#post-credit-plan .double-container .right-container-info .data-values > div p.above,
#post-credit-plan .double-container .right-container .payment-capacity .data-values > div p.above {
  font-size: 11px;
  font-weight: 400;
  color: var(--sebrae-dark-green2);
}
#post-credit-plan .double-container .right-container-info .data-graphic,
#post-credit-plan .double-container .right-container .payment-capacity .data-graphic {
  flex: 1 1;
  min-height: 260px;
}
#post-credit-plan .double-container .right-container-info .data-graphic canvas,
#post-credit-plan .double-container .right-container .payment-capacity .data-graphic canvas {
  max-width: 440px;
}
@media (min-width: 1120px) {
  #post-credit-plan .double-container .right-container-info .data-graphic canvas,
  #post-credit-plan .double-container .right-container .payment-capacity .data-graphic canvas {
    max-width: 515px;
  }
}
@media (min-width: 1260px) {
  #post-credit-plan .double-container .right-container-info .data,
  #post-credit-plan .double-container .right-container .payment-capacity .data {
    flex-direction: row;
  }
  #post-credit-plan .double-container .right-container-info .data-graphic canvas,
  #post-credit-plan .double-container .right-container .payment-capacity .data-graphic canvas {
    max-width: 420px;
  }
}
#post-credit-plan .double-container .right-container .payment-capacity {
  width: auto;
}
#post-credit-plan .double-container .right-container .payment-capacity h4 {
  font-size: 23px;
  font-weight: 700;
  color: var(--sebrae-blue-6);
}
#post-credit-plan .send-button {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
#post-credit-plan .send-button button {
  width: 70px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--sebrae-dark-gray2);
  border-radius: 4px;
}
#post-credit-plan .send-button button span {
  font-size: 13px;
  color: var(--sebrae-dark-gray2);
}

.post-credit-cash-flow {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}
.post-credit-cash-flow .cash-flow-info-box {
  background-color: #e4f998;
  border-radius: 6px;
  max-height: 200px;
  opacity: 1;
  padding: 8px 16px 16px;
  overflow: hidden;
  transition: max-height 0.35s ease, padding 0.35s ease, opacity 0.35s ease, margin-bottom 0.35s ease;
}
.post-credit-cash-flow .cash-flow-info-box .information-box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.post-credit-cash-flow .cash-flow-info-box .information-box-header span {
  font-size: 16px;
  font-weight: 700;
  color: var(--sebrae-blue-6);
  line-height: 23.3px;
}
.post-credit-cash-flow .cash-flow-info-box p {
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  margin: 0;
}
.post-credit-cash-flow .cash-flow-info-box.collapsed {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
  margin-bottom: 0;
}
.post-credit-cash-flow .cash-flow-info-box.collapsed.hidden {
  display: none;
}
.post-credit-cash-flow .cash-flow-date-container {
  padding: 8px;
  background-color: var(--sebrae-light-blue3);
  font-size: 13px;
  font-weight: 700;
  color: var(--sebrae-blue-2);
  border-radius: 4px;
  text-align: center;
}
.post-credit-cash-flow .cash-flow-main-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.post-credit-cash-flow .cash-flow-main-content h4 {
  font-size: 16px;
  font-weight: 700;
  color: var(--sebrae-blue-6);
  margin: 0 0 12px 0;
}
.post-credit-cash-flow .cash-flow-main-content .BaSe--input {
  max-width: unset;
}
.post-credit-cash-flow .cash-flow-exit-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.post-credit-cash-flow .cash-flow-exit-grid .BaSe--input {
  margin-bottom: 0;
}
.post-credit-cash-flow .cash-flow-exit-item {
  display: grid;
  grid-template-columns: 157px 157px 1fr;
  gap: 16px;
  align-items: center;
}
.post-credit-cash-flow .cash-flow-exit-item .toggle-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
}
.post-credit-cash-flow .cash-flow-toggler {
  display: flex;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.post-credit-cash-flow .cash-flow-toggler .toggler-track {
  position: relative;
  width: 52px;
  height: 28px;
  border-radius: 14px;
  background: #83bf30;
  transition: background 0.35s ease;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
}
.post-credit-cash-flow .cash-flow-toggler .toggler-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.post-credit-cash-flow .cash-flow-toggler .toggler-status {
  font-size: 14px;
  font-weight: 600;
  min-width: 70px;
  transition: color 0.3s ease;
}
.post-credit-cash-flow .cash-flow-toggler.paid .toggler-track {
  background: #bf303c;
}
.post-credit-cash-flow .cash-flow-toggler.paid .toggler-thumb {
  transform: translateX(0);
}
.post-credit-cash-flow .cash-flow-toggler.paid .toggler-status {
  color: #bf303c;
}
.post-credit-cash-flow .cash-flow-toggler.pending .toggler-track {
  background: #83bf30;
}
.post-credit-cash-flow .cash-flow-toggler.pending .toggler-thumb {
  transform: translateX(24px);
}
.post-credit-cash-flow .cash-flow-toggler.pending .toggler-status {
  color: #83bf30;
}
.post-credit-cash-flow .cash-flow-toggler:focus-visible {
  outline: 2px solid var(--sebrae-blue-6);
  outline-offset: 2px;
  border-radius: 4px;
}

.post-credit-section .deadlines__wrapper-inline {
  margin-top: -2px;
}
.post-credit-section .deadlines__wrapper-inline .BaSe--input {
  margin-top: 4px;
}
.post-credit-section .deadline-row {
  gap: 16px;
  display: flex;
  align-items: flex-end;
}
.post-credit-section .deadline-select-wrapper {
  height: 59px;
  max-width: 180px;
}
.post-credit-section .deadlines__wrapper-inline,
.post-credit-section .BaSe--select,
.post-credit-section .BaSe--select > input {
  height: 36px;
}
.post-credit-section label {
  font-size: 16px;
  line-height: 23px;
}
.post-credit-section .BaSe--grid {
  gap: 16px !important;
  align-items: flex-end;
}
.post-credit-section .BaSe--grid-item .BaSe--input {
  margin-bottom: 0;
}
.post-credit-section .BaSe--grid-item .BaSe--input input {
  color: var(--sebrae-gray);
  border: 1px solid var(--sebrae-light-gray2);
}
.post-credit-section .BaSe--select {
  margin-top: -2px;
}
.post-credit-section .BaSe--select-input {
  color: var(--sebrae-gray);
  border: 1px solid var(--sebrae-light-gray2);
}
.post-credit-section .BaSe--select div:nth-child(4) {
  display: none;
}
.post-credit-section .BaSe--select div:nth-child(2) {
  right: 50px;
}
.post-credit-section .BaSe--select div[role=menu] {
  width: 170px;
}
.post-credit-section .base-input-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
.post-credit-section .icon-wrapper {
  height: 36px;
  display: flex;
  align-items: center;
}
.post-credit-section .input-100 .BaSe--input {
  margin: 0;
}
.post-credit-section .input-100 .BaSe--input .BaSe--input-wrapper {
  border-radius: 4px;
  overflow: hidden;
}
.post-credit-section .input-100 .BaSe--input input {
  color: var(--sebrae-gray);
  background: var(--sebrae-white);
  border-radius: 4px !important;
  border-width: 2px !important;
  border-image-slice: 1 !important;
  border-image-source: linear-gradient(to right, #3b4aff 0%, #40bbff 100%) !important;
}
.post-credit-section .input-not-100 .BaSe--input {
  margin: 0;
}
.post-credit-section .input-not-100 .BaSe--input .BaSe--input-wrapper {
  border-radius: 4px;
  overflow: hidden;
}
.post-credit-section .input-not-100 .BaSe--input input {
  color: var(--sebrae-gray);
  background: var(--sebrae-white);
  border-radius: 4px !important;
  border-width: 2px !important;
  border-image-slice: 1 !important;
  border-image-source: linear-gradient(to right, #ff3b3b 0%, #760303 100%) !important;
}
.post-credit-section .sum-warning {
  text-align: center;
  margin-top: 16px;
}
.post-credit-section .sum-warning span {
  font-size: 11px;
  color: var(--sebrae-dark-gray);
}
.post-credit-section .sum-warning span strong {
  font-weight: 700;
}
.post-credit-section .btn-add-more {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px auto 0;
  color: var(--sebrae-blue-6);
  font-size: 13px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/pages/post-credit/results/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,2BAAA;EACA,kDAAA;AACF;AACE;EACE,UAAA;EACA,wBAAA;AACJ;AAEE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAAJ;AAGE;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;AADJ;AAGI;EACE,SAAA;EACA,aAAA;EACA,mBAAA;AADN;AAII;EACE,YAAA;EACA,YAAA;AAFN;AAKI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;AAHN;AAMI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AAJN;AAQE;EACE,SAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4FAAA;AANJ;AASI;EACE,iBAAA;AAPN;AAUI;EACE,aAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;AARN;AAWI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AATN;AAWM;EACE,eAAA;EACA,+BAAA;AATR;AAWQ;EACE,qBAAA;AATV;AAcI;EACE,QAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AAZN;AAcM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAZR;AAcQ;EACE,gBAAA;AAZV;AAiBI;EACE,UAAA;AAfN;AAkBI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AAhBN;AAoBE;EACE,gBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AAlBJ;AAoBI;EANF;IAOI,SAAA;EAjBJ;AACF;AAmBI;;EAEE,SAAA;AAjBN;AAoBI;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,2CAAA;EACA,0CAAA;AAlBN;AAoBM;EACE,QAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAlBR;AAqBM;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;AAnBR;AAsBM;EACE,WAAA;EACA,kBAAA;AApBR;AAsBQ;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;AApBV;AAuBQ;EACE,SAAA;EACA,aAAA;EACA,eAAA;AArBV;AAuBU;EACE,SAAA;AArBZ;AA8BQ;;;;;;EAEE,aAAA;AAxBV;AA0BQ;;;EACE,gBAAA;AAtBV;AA2BQ;EACE,gBAAA;EACA,oBAAA;AAzBV;AA6BM;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AA3BR;AA6BQ;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AA3BV;AA6BU;EACE,aAAA;EACA,2BAAA;EACA,QAAA;AA3BZ;AA4BY;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AA1Bd;AA8BU;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA5BZ;AA8BY;EACE,eAAA;EACA,gBAAA;AA5Bd;AAiCQ;EACE,YAAA;EACA,YAAA;EACA,sCAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AA/BV;AAqCM;EACE,iBAAA;AAnCR;AAsCM;EACE,SAAA;EACA,aAAA;EACA,cAAA;AApCR;AAuCM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AArCR;AAwCM;EACE,aAAA;EACA,oBAAA;EACA,8BAAA;AAtCR;AAwCQ;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;AAtCV;AAyCQ;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AAvCV;AA2CM;;EAEE,WAAA;AAzCR;AA2CQ;;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,8BAAA;AAxCV;AA0CU;;EACE,aAAA;EACA,gBAAA;EACA,0BAAA;EACA,2CAAA;AAvCZ;AAyCY;;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAtCd;AAyCY;;EACE,eAAA;EACA,gBAAA;AAtCd;AAyCY;;EACE,eAAA;EACA,gBAAA;AAtCd;AAwCc;;EACE,cAAA;AArChB;AAwCc;;EACE,cAAA;AArChB;AAwCc;;EACE,cAAA;AArChB;AAwCc;;EACE,cAAA;AArChB;AA0CU;;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AAvCZ;AAyCY;;EACE,aAAA;EACA,kBAAA;EACA,2CAAA;AAtCd;AAwCc;;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AArChB;AAwCc;;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AArChB;AAwCc;;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AArChB;AAuCgB;;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;AApClB;AAuCgB;;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;AApClB;AA0CU;;EACE,SAAA;EACA,iBAAA;AAvCZ;AAyCY;;EACE,gBAAA;AAtCd;AA0CU;EAEI;;IACE,gBAAA;EAxCd;AACF;AA4CU;EA9GF;;IA+GI,mBAAA;EAxCV;EA2CY;;IACE,gBAAA;EAxCd;AACF;AA8CM;EACE,WAAA;AA5CR;AA8CQ;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;AA5CV;AAkDE;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAhDJ;AAiDI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,kBAAA;AA/CN;AAgDM;EACE,eAAA;EACA,+BAAA;AA9CR;;AAoDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AAjDF;AAoDI;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,mGAAA;AAlDN;AAqDM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAnDR;AAqDQ;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;AAnDV;AAuDM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AArDR;AAwDM;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;AAtDR;AAyDM;EACE,aAAA;AAvDR;AA2DI;EACE,YAAA;EACA,2CAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;AAzDN;AA4DI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA1DN;AA4DM;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;AA1DR;AA6DM;EACE,gBAAA;AA3DR;AA+DI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA7DN;AA+DM;EACE,gBAAA;AA7DR;AAiEI;EACE,aAAA;EACA,sCAAA;EACA,SAAA;EACA,mBAAA;AA/DN;AAiEM;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA/DR;AAmEI;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAjEN;AAmEM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,iCAAA;EACA,8CAAA;AAjER;AAoEM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,yCAAA;EACA,uDAAA;AAlER;AAqEM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AAnER;AAuEQ;EACE,mBAAA;AArEV;AAuEQ;EACE,wBAAA;AArEV;AAuEQ;EACE,cAAA;AArEV;AA0EQ;EACE,mBAAA;AAxEV;AA0EQ;EACE,2BAAA;AAxEV;AA0EQ;EACE,cAAA;AAxEV;AA4EM;EACE,uCAAA;EACA,mBAAA;EACA,kBAAA;AA1ER;;AAiFE;EACE,gBAAA;AA9EJ;AA+EI;EACE,eAAA;AA7EN;AAgFE;EACE,SAAA;EACA,aAAA;EACA,qBAAA;AA9EJ;AAgFE;EACE,YAAA;EACA,gBAAA;AA9EJ;AAgFE;;;EAGE,YAAA;AA9EJ;AAgFE;EACE,eAAA;EACA,iBAAA;AA9EJ;AAgFE;EACE,oBAAA;EACA,qBAAA;AA9EJ;AAiFI;EACE,gBAAA;AA/EN;AAgFM;EACE,yBAAA;EACA,2CAAA;AA9ER;AAkFE;EACE,gBAAA;AAhFJ;AAiFI;EACE,yBAAA;EACA,2CAAA;AA/EN;AAiFI;EACE,aAAA;AA/EN;AAiFI;EACE,WAAA;AA/EN;AAiFI;EACE,YAAA;AA/EN;AAkFE;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAhFJ;AAkFE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAhFJ;AAmFI;EACE,SAAA;AAjFN;AAmFM;EACE,kBAAA;EACA,gBAAA;AAjFR;AAmFM;EACE,yBAAA;EACA,+BAAA;EACA,6BAAA;EACA,4BAAA;EACA,gCAAA;EACA,mFAAA;AAjFR;AA0FI;EACE,SAAA;AAxFN;AA0FM;EACE,kBAAA;EACA,gBAAA;AAxFR;AA2FM;EACE,yBAAA;EACA,+BAAA;EACA,6BAAA;EACA,4BAAA;EACA,gCAAA;EACA,mFAAA;AAzFR;AAiGE;EACE,kBAAA;EACA,gBAAA;AA/FJ;AAgGI;EACE,eAAA;EACA,8BAAA;AA9FN;AA+FM;EACE,gBAAA;AA7FR;AAiGE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;EAEE,eAAA;EACA,gBAAA;AAhGN","sourcesContent":["#post-credit-plan {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #ffffff;\n  z-index: 9999;\n  overflow-y: auto;\n  opacity: 0;\n  transform: translateY(20px);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n\n  &.modal-open {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  .container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 20px;\n    margin-bottom: 64px;\n  }\n\n  .header {\n    display: flex;\n    margin-top: 28px;\n    margin-bottom: 32px;\n    justify-content: space-between;\n\n    &-middle {\n      gap: 16px;\n      display: flex;\n      align-items: center;\n    }\n\n    img {\n      width: 209px;\n      height: 20px;\n    }\n\n    h2 {\n      font-size: 33px;\n      font-weight: 700;\n      font-style: normal;\n      font-family: \"Campuni\";\n      color: var(--sebrae-blue-6);\n    }\n\n    h4 {\n      font-size: 19px;\n      font-weight: 400;\n      font-style: normal;\n      color: var(--sebrae-blue-2);\n    }\n  }\n\n  .information-box {\n    gap: 20px;\n    display: flex;\n    padding: 8px 16px;\n    border-radius: 4px;\n    flex-direction: column;\n    background-color: #ebe8ff;\n    max-height: 1000px;\n    overflow: hidden;\n    transition: max-height 0.4s ease, padding 0.4s ease, opacity 0.3s ease,\n      min-height 0.4s ease;\n\n    &:not(.collapsed) {\n      min-height: 128px;\n    }\n\n    &.collapsed {\n      max-height: 0;\n      min-height: 0;\n      padding: 0 16px;\n      opacity: 0;\n    }\n\n    &-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      flex-shrink: 0;\n\n      svg {\n        cursor: pointer;\n        transition: transform 0.2s ease;\n\n        &:hover {\n          transform: scale(1.2);\n        }\n      }\n    }\n\n    &-texts {\n      gap: 8px;\n      display: flex;\n      flex-direction: column;\n      transition: opacity 0.3s ease;\n\n      p {\n        font-size: 13px;\n        font-weight: 400;\n        font-style: normal;\n\n        span {\n          font-weight: 700;\n        }\n      }\n    }\n\n    &.collapsed &-texts {\n      opacity: 0;\n    }\n\n    h4 {\n      font-size: 16px;\n      margin-top: 4px;\n      font-weight: 700;\n      font-style: normal;\n      color: var(--sebrae-blue-6);\n    }\n  }\n\n  .double-container {\n    margin-top: 32px;\n    gap: 20px;\n    width: 100%;\n    display: flex;\n\n    @media (min-width: 1100px) {\n      gap: 40px;\n    }\n\n    .left-container,\n    .right-container {\n      flex: 1;\n    }\n\n    .left-container {\n      max-width: 500px;\n      padding: 32px;\n      border-radius: 8px;\n      border: 1px solid var(--sebrae-light-gray4);\n      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);\n\n      &-title {\n        gap: 8px;\n        display: flex;\n        margin-bottom: 24px;\n        flex-direction: column;\n      }\n\n      h3 {\n        font-size: 27px;\n        font-weight: 700;\n        font-family: Campuni;\n        color: var(--sebrae-blue-6);\n      }\n\n      .left-content {\n        width: 100%;\n        margin-top: 10.5px;\n\n        h6 {\n          font-size: 16px;\n          font-weight: 700;\n          color: var(--sebrae-blue-6);\n        }\n\n        .first-row {\n          gap: 16px;\n          display: flex;\n          margin-top: 8px;\n\n          input {\n            flex: 1;\n          }\n        }\n      }\n\n      // Estilizações dos passos de pós-credito - componentes importados de planning\n      > .accordion-graphics-container > .panel > div > .monthly-average,\n      .variable-indirect-costs,\n      .total-investment {\n        .step--info,\n        .BaSe--input-sub-label {\n          display: none;\n        }\n        .BaSe--input {\n          margin-bottom: 0;\n        }\n      }\n\n      > .accordion-graphics-container > .panel > div > .total-investment {\n        .BaSe--grid {\n          align-items: end;\n          gap: 16px !important;\n        }\n      }\n\n      .finish-month {\n        display: flex;\n        justify-content: flex-end;\n        margin-top: 24px;\n\n        &-info {\n          display: flex;\n          padding: 24px;\n          flex-direction: column;\n          background-color: #ebe8ff;\n\n          &-header {\n            display: flex;\n            justify-content: flex-start;\n            gap: 4px;\n            h4 {\n              font-size: 16px;\n              font-weight: 700;\n              font-style: normal;\n              color: var(--sebrae-blue-6);\n            }\n          }\n\n          &-texts {\n            margin-top: 4px;\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n\n            p {\n              font-size: 13px;\n              font-weight: 400;\n            }\n          }\n        }\n\n        button {\n          height: 40px;\n          width: 156px;\n          background-color: var(--sebrae-blue-6);\n          color: var(--sebrae-white);\n          border: none;\n          border-radius: 4px;\n          font-size: 18px;\n          line-height: 23.3px;\n          cursor: pointer;\n        }\n      }\n    }\n\n    .right-container {\n      .step-components-area {\n        padding: 0 74.5px;\n      }\n\n      .date-area {\n        gap: 24px;\n        display: flex;\n        margin: 24px 0;\n      }\n\n      &-description {\n        font-size: 19px;\n        font-weight: 400;\n        margin-top: 16px;\n        margin-bottom: 24px;\n        color: var(--sebrae-gray);\n      }\n\n      &-header {\n        display: flex;\n        font-family: Campuni;\n        justify-content: space-between;\n\n        h2 {\n          font-size: 36px;\n          font-weight: 700;\n          color: var(--sebrae-blue-6);\n        }\n\n        button {\n          font-size: 16px;\n          max-width: 144px;\n          font-weight: 700;\n          font-family: Figtree;\n        }\n      }\n\n      &-info,\n      .payment-capacity {\n        width: 100%;\n\n        .data {\n          gap: 24px;\n          display: flex;\n          margin-top: 24px;\n          flex-direction: column;\n          justify-content: space-between;\n\n          &-values-matriz {\n            padding: 16px;\n            margin-top: 24px;\n            border-radius: 0 0 4px 4px;\n            border: 1px solid var(--sebrae-light-blue3);\n\n            h4 {\n              font-size: 16px;\n              font-weight: 700;\n              margin-bottom: 8px;\n              color: var(--sebrae-blue);\n            }\n\n            .value {\n              font-size: 19px;\n              font-weight: 700;\n            }\n\n            .nivel {\n              font-size: 11px;\n              font-weight: 400;\n\n              &.baixo {\n                color: #3cb371;\n              }\n\n              &.moderado {\n                color: #664d1a;\n              }\n\n              &.alto {\n                color: #ff7043;\n              }\n\n              &.critico {\n                color: #d9534f;\n              }\n            }\n          }\n\n          &-values {\n            display: flex;\n            gap: 24px;\n            width: 260px;\n            max-width: 240px;\n            flex-direction: column;\n\n            > div {\n              padding: 16px;\n              border-radius: 4px;\n              border: 1px solid var(--sebrae-light-blue3);\n\n              h4 {\n                font-size: 16px;\n                font-weight: 600;\n                margin-bottom: 8px;\n                color: var(--sebrae-blue);\n              }\n\n              .value {\n                display: block;\n                font-size: 19px;\n                font-weight: 700;\n                color: var(--sebrae-gray);\n              }\n\n              p {\n                font-size: 13px;\n                margin-top: 2px;\n                font-weight: 600;\n\n                &.below {\n                  font-size: 11px;\n                  font-weight: 400;\n                  color: var(--sebrae-red);\n                }\n\n                &.above {\n                  font-size: 11px;\n                  font-weight: 400;\n                  color: var(--sebrae-dark-green2);\n                }\n              }\n            }\n          }\n\n          &-graphic {\n            flex: 1;\n            min-height: 260px;\n\n            canvas {\n              max-width: 440px;\n            }\n          }\n\n          @media (min-width: 1120px) {\n            &-graphic {\n              canvas {\n                max-width: 515px;\n              }\n            }\n          }\n\n          @media (min-width: 1260px) {\n            flex-direction: row;\n\n            &-graphic {\n              canvas {\n                max-width: 420px;\n              }\n            }\n          }\n        }\n      }\n\n      .payment-capacity {\n        width: auto;\n\n        h4 {\n          font-size: 23px;\n          font-weight: 700;\n          color: var(--sebrae-blue-6);\n        }\n      }\n    }\n  }\n\n  .send-button {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 16px;\n    button {\n      width: 70px;\n      height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border: 1px solid var(--sebrae-dark-gray2);\n      border-radius: 4px;\n      span {\n        font-size: 13px;\n        color: var(--sebrae-dark-gray2);\n      }\n    }\n  }\n}\n\n.post-credit-cash-flow {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n\n  .cash-flow {\n    &-info-box {\n      background-color: #e4f998;\n      border-radius: 6px;\n      max-height: 200px;\n      opacity: 1;\n      padding: 8px 16px 16px;\n      overflow: hidden;\n      transition: max-height 0.35s ease, padding 0.35s ease, opacity 0.35s ease,\n        margin-bottom 0.35s ease;\n\n      .information-box-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 8px;\n\n        span {\n          font-size: 16px;\n          font-weight: 700;\n          color: var(--sebrae-blue-6);\n          line-height: 23.3px;\n        }\n      }\n\n      p {\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 1.4;\n        margin: 0;\n      }\n\n      &.collapsed {\n        max-height: 0;\n        padding-top: 0;\n        padding-bottom: 0;\n        opacity: 0;\n        margin-bottom: 0;\n      }\n\n      &.collapsed.hidden {\n        display: none;\n      }\n    }\n\n    &-date-container {\n      padding: 8px;\n      background-color: var(--sebrae-light-blue3);\n      font-size: 13px;\n      font-weight: 700;\n      color: var(--sebrae-blue-2);\n      border-radius: 4px;\n      text-align: center;\n    }\n\n    &-main-content {\n      display: flex;\n      flex-direction: column;\n      gap: 24px;\n\n      h4 {\n        font-size: 16px;\n        font-weight: 700;\n        color: var(--sebrae-blue-6);\n        margin: 0 0 12px 0;\n      }\n\n      .BaSe--input {\n        max-width: unset;\n      }\n    }\n\n    &-exit-grid {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n\n      .BaSe--input {\n        margin-bottom: 0;\n      }\n    }\n\n    &-exit-item {\n      display: grid;\n      grid-template-columns: 157px 157px 1fr;\n      gap: 16px;\n      align-items: center;\n\n      .toggle-wrapper {\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 9px;\n      }\n    }\n\n    &-toggler {\n      display: flex;\n      gap: 10px;\n      cursor: pointer;\n      user-select: none;\n\n      .toggler-track {\n        position: relative;\n        width: 52px;\n        height: 28px;\n        border-radius: 14px;\n        background: #83bf30;\n        transition: background 0.35s ease;\n        box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);\n      }\n\n      .toggler-thumb {\n        position: absolute;\n        top: 3px;\n        left: 3px;\n        width: 22px;\n        height: 22px;\n        border-radius: 50%;\n        background-color: white;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);\n        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n      }\n\n      .toggler-status {\n        font-size: 14px;\n        font-weight: 600;\n        min-width: 70px;\n        transition: color 0.3s ease;\n      }\n\n      &.paid {\n        .toggler-track {\n          background: #bf303c;\n        }\n        .toggler-thumb {\n          transform: translateX(0);\n        }\n        .toggler-status {\n          color: #bf303c;\n        }\n      }\n\n      &.pending {\n        .toggler-track {\n          background: #83bf30;\n        }\n        .toggler-thumb {\n          transform: translateX(24px);\n        }\n        .toggler-status {\n          color: #83bf30;\n        }\n      }\n\n      &:focus-visible {\n        outline: 2px solid var(--sebrae-blue-6);\n        outline-offset: 2px;\n        border-radius: 4px;\n      }\n    }\n  }\n}\n\n.post-credit-section {\n  .deadlines__wrapper-inline {\n    margin-top: -2px;\n    .BaSe--input {\n      margin-top: 4px;\n    }\n  }\n  .deadline-row {\n    gap: 16px;\n    display: flex;\n    align-items: flex-end;\n  }\n  .deadline-select-wrapper {\n    height: 59px;\n    max-width: 180px;\n  }\n  .deadlines__wrapper-inline,\n  .BaSe--select,\n  .BaSe--select > input {\n    height: 36px;\n  }\n  label {\n    font-size: 16px;\n    line-height: 23px;\n  }\n  .BaSe--grid {\n    gap: 16px !important;\n    align-items: flex-end;\n  }\n  .BaSe--grid-item {\n    .BaSe--input {\n      margin-bottom: 0;\n      input {\n        color: var(--sebrae-gray);\n        border: 1px solid var(--sebrae-light-gray2);\n      }\n    }\n  }\n  .BaSe--select {\n    margin-top: -2px;\n    &-input {\n      color: var(--sebrae-gray);\n      border: 1px solid var(--sebrae-light-gray2);\n    }\n    div:nth-child(4) {\n      display: none;\n    }\n    div:nth-child(2) {\n      right: 50px;\n    }\n    div[role=\"menu\"] {\n      width: 170px;\n    }\n  }\n  .base-input-container {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 16px;\n  }\n  .icon-wrapper {\n    height: 36px;\n    display: flex;\n    align-items: center;\n  }\n  .input-100 {\n    .BaSe--input {\n      margin: 0;\n\n      .BaSe--input-wrapper {\n        border-radius: 4px;\n        overflow: hidden;\n      }\n      input {\n        color: var(--sebrae-gray);\n        background: var(--sebrae-white);\n        border-radius: 4px !important;\n        border-width: 2px !important;\n        border-image-slice: 1 !important;\n        border-image-source: linear-gradient(\n          to right,\n          #3b4aff 0%,\n          #40bbff 100%\n        ) !important;\n      }\n    }\n  }\n  .input-not-100 {\n    .BaSe--input {\n      margin: 0;\n\n      .BaSe--input-wrapper {\n        border-radius: 4px;\n        overflow: hidden;\n      }\n\n      input {\n        color: var(--sebrae-gray);\n        background: var(--sebrae-white);\n        border-radius: 4px !important;\n        border-width: 2px !important;\n        border-image-slice: 1 !important;\n        border-image-source: linear-gradient(\n          to right,\n          #ff3b3b 0%,\n          #760303 100%\n        ) !important;\n      }\n    }\n  }\n  .sum-warning {\n    text-align: center;\n    margin-top: 16px;\n    span {\n      font-size: 11px;\n      color: var(--sebrae-dark-gray);\n      strong {\n        font-weight: 700;\n      }\n    }\n  }\n  .btn-add-more {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 16px auto 0;\n    color: var(--sebrae-blue-6);\n    font: {\n      size: 13px;\n      weight: 700;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
